
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Family, Invoice } from '@/types/models';
import InvoiceForm, { InvoiceFormValues } from './InvoiceForm';

interface InvoiceDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  families: Family[];
  invoice?: Invoice;
  onSubmit: (data: InvoiceFormValues) => Promise<void>;
  title: string;
  initialFamilyId?: string;
}

const InvoiceDialog: React.FC<InvoiceDialogProps> = ({ 
  open, 
  onOpenChange, 
  families, 
  invoice, 
  onSubmit,
  title,
  initialFamilyId
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <InvoiceForm 
          families={families}
          invoice={invoice}
          onSubmit={onSubmit}
          onCancel={() => onOpenChange(false)}
          initialFamilyId={initialFamilyId}
        />
      </DialogContent>
    </Dialog>
  );
};

export default InvoiceDialog;
